<div class="menu-indice">Gestión de Constancias de {{tipo_participante}}</div>
<mdb-card>
    <mdb-card-body>
        <div class="form-row align-items-center" *ngIf="c_perfil == '2'">
            <div class="form-group col-md-6">
                <div class="md-form mt-0 mb-0">
                    <input type="text" id="txt_nombre" maxlength="100" [(ngModel)]="txt_nombre" class="form-control" mdbInput>
                    <label for="txt_nombres">Nombre</label>
                </div>
            </div>
            <div class="form-group col-md-2">
              <button mdbBtn type="button" id="btnBuscar"  (click)="onBuscar()"  size="sm" color="blue" mdbWavesEffect>
              <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>
            </div>
        </div>

        <div class="form-row align-items-center" *ngIf="c_iduser == '1'">
          <div class="form-group col-md-2">Firmante :</div>
          <div class="form-group col-md-3">
            <select class="browser-default custom-select" [(ngModel)]="c_iduser_firmante" (change)="onUsuarioChange()">
                  <option value="0" selected>Seleccione</option>
                  <option *ngFor="let listUser of listUsuarios" [value]="listUser.c_usuario">{{listUser.x_nombres}} {{listUser.x_ape_pat}} {{listUser.x_ape_mat}}</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <button mdbBtn type="button" id="btnBuscar"  (click)="onBuscarConstanciasFirmante()"  size="sm" color="blue" mdbWavesEffect>
            <mdb-icon fas icon="search" class="mr-1"></mdb-icon>Buscar</button>
          </div>
          <div class="form-group col-md-5" style="color: gray">{{x_oficina}}</div>
        </div>
    </mdb-card-body>
  </mdb-card>
  <br/>
  <mdb-card *ngIf="(c_perfil == '2') || (c_iduser == '1')">
    <div class="table-responsive">
    <table mdbTable hover="true" class="table">
        <thead>
          <tr>
            <th scope="col">Nro</th>
            <th scope="col">Fecha Emision</th>
            <th scope="col">Formato</th>
            <th scope="col">Curso</th>
            <th scope="col">{{tipo_participante}}</th>
          </tr>
        </thead>
        <tbody>
          <tr mdbTableCol *ngFor="let listConst of listConstancias | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize ;let i = index">
            <th>{{i + 1}}</th>
            <th>
               <span>{{listConst.f_constancia}}</span>
            </th>
            <th>{{listConst.x_titulo}}</th>
            <td>{{listConst.x_curso}}</td>
            <td><button type="button" (click)="onVerParticipante(listConst)" color="blue" outline="true" class="btn-sm" mdbWavesEffect mdbBtn><mdb-icon fas icon="users" size="lg"></mdb-icon></button></td>

          </tr>
        </tbody>
      </table>
      </div>
        <div class="text-center">

          <ngb-pagination [maxSize]=4 [(page)]="page" class="d-flex justify-content-center"
            [pageSize]="pageSize" [boundaryLinks]="true" [collectionSize]="listConstancias.length">
          </ngb-pagination>

        </div>

  </mdb-card>
